angular.module('aprima-core-ui').directive('select', [function () {
    'use strict';

    return {
        restrict: 'E',
        compile : function(element){
            //fix iOS off by one error for all select
            element.prepend($('<option value=""></option>'));
        }
    };
}]);
